<template>
  <div class="body">
        <h1 class="tcTitle center">Privacy Policy</h1>
        <h1 class="sdgTitle center">SDG</h1>
        <p>
            This Privacy Notice (“Notice”) explains how Soli Deo Gloria Releasing, LLC (“SDG”) collects, uses and discloses information about SDG clients and others who visit SDG websites. The terms “we”, “us” and “our” refer to SDG and its affiliates, which collectively own and operate a transactional video (TVOD) direct digital download platform, as well as any other services that are available from SDG now or in the future (collectively “Services”). The term “you” refers to you as a buyer or user of our Services, including the aforementioned TVOD purchases and downloads, software or mobile applications. Your use of our services constitutes your acceptance of this Notice.
        </p>
        <p class="titleBold">
            Collection and Use of Your Personal Information
        </p>
        <p>
            We collect and maintain regular business records containing information about you which may constitute Personally Identifiable Information (“PII”), including but not limited to your name, billing address, email address, phone number, credit card number, and other account information. You are not required to provide the personal information, but if you elect not to do so, it is likely that we will not be able to provide you with the products or services we have to offer. The personal information we collect will allow us to keep you posted of additional products and services which may become available.  
        </p>
        <p class="titleBold">
            Third Party Information; Third-Party Services and Websites
        </p>
        <p>
            We may receive information about you from third parties, such as business partners and data companies. You many also access third party products, services, applications or websites  through SDG. If you elect to share information with such third party/ies, please be aware that disclosure of such information will be subject to that third party/ies’ privacy policies, which may differ from ours. We are not responsible for the practices of such third party/ies.
        </p>
        <p class="titleBold">
            Cookies and Other Technologies 
        </p>
        <p>
            Our Services may be provided through internet websites and/or other platforms operated by us, our affiliates and/or other entities. We and/or they may use cookies or other technologies to track users online and to collect certain information which may include, but is not limited to, statistics about platform usage, IP addresses, browser and device type/s, Internet Service Provider, date/time stamp, number of clicks, and other information.
        </p>
        <p class="titleBold">
                How Do We Use Your Information? 
        </p>
        <p>
            We use information we receive from and about you and your account primarily to conduct business activities, including but not limited to: 
        </p>
        <ul>
            <li>
                Billing and collections
            </li>
            <li>
                Installation, operation and maintenance of our Services
            </li>
            <li>
                Confirmation that you are receiving (or have received) Services for which you have been billed
            </li>
            <li>
                Making programming recommendations 
            </li>
            <li>
                Marketing our Services, and those of our business partners,
            </li>
            <li>
                Detection of unauthorized users
            </li>
            <li>
                Determination of whether terms of use are being violated,
            </li>
            <li>
                    Configuration of Service-related devices
            </li>
            <li>
                    Statistical, quantitative and qualitative analysis
            </li>
            <li>
                    Compliance with applicable laws
            </li>
            <li>
                    Any other activities we reasonably deem necessary to provide our Services
            </li>
        </ul>
        <p>
                We are free to use the information collected (including PII) to improve, measure and/or analyze our Services, to provide more relevant marketing, and for analytical and/or reporting purposes. 
                We may also combine your information, including PII, with that received from third party sources, without restriction. 
                
        </p>
        <p class="titleBold">
                What Information of Yours Do We Disclose to Others?
 
        </p>
        <p>
                SDG treats information about you (including PII) as confidential. However we cannot guarantee that these efforts and practices will prevent every unauthorized attempt to access, use, or disclose your information, including PII. In the normal course of business, we may also disclose or share your information, including PII, with other entities which provide services to SDG, including but not limited to billing and collections, administration, marketing, administration, maintenance and operations, and fraud prevention. We will use reasonable precautions in order to limit such disclosure/s to responsible parties. We may share such information with government agencies, if required by law or valid court order. We may also share such information with third parties that provide content, services or technologies used in, with, or in support of our Services. 
        </p>
        <p class="titleBold">
            How Your Information May Be Used for Advertising Purposes
 
        </p>
        <p>
            We may use your information (including but not limited to demographics, past purchases, and program viewing data) to provide you with advertising from us and our advertising partners. We may also use combine your information with other aggregated, de-identified information to create groups based on actual or assumed shared interests in order to target relevant advertising.
        </p>
        <p class="titleBold">
                What Choices Do You Have?
     
        </p>
        <p>
            You can adjust your device or browser to limit tracking or decline cookies, but this may limit our ability to provide you with our Services. We apologize for any inconvenience this may cause, and we regret that we do not currently have the capability to provide an alternate Services path for you. 
        </p>
        <p class="titleBold">
                Enhanced Privacy Rights If You Are A Resident of California
     
        </p>
        <p>
                California law permits California residents to request certain details regarding how their PII is shared with third parties for direct marketing purposes. If you are a California resident and would like to make such a request, please contact us at the address shown below. You must clearly include “Your California Privacy Rights” on the request letter, the signature for which must also be notarized by a California licensed notary public. We are not responsible for any notices which are not properly labeled or sent, or do not have complete information and/or notarization. Please include a stamped, self-addressed envelope with your request. 
        </p>
        <p>
            Mailing address: 
        </p>
        <p>SDG Releasing</p>
        <p>135 East Olive Ave.</p>
        <p>#191</p>
        <p>Burbank, CA 91502</p>
        <p class="titleBold">
            Protecting Your PII     
        </p>
        <p>
            We use commercially reasonable efforts to prevent third party access to your information, including PII. We may also maintain information about you for a period not to exceed seven years after your last purchase and/or use of Services, partly (but not exclusively) in order to comply with governmental audit requirements.
        </p>
        <p class="titleBold">
            Modification of Privacy Policy     
        </p>
        <p>
            We may modify this notice at any time. Unless required by law, given the transactional nature of our TVOD Services, we will not notify you unless required by law. You may, however, access a copy the current version at any time on our website.
        </p>
  </div>
</template>

<script>
import { EventBus } from "@/main";

export default {
  created () {
    console.log(this.$route.params);
  },
  mounted () {
    if (this.$route.params && this.$route.params.id === 'About') {
        EventBus.$emit("AboutPopup");
    }
  }
}
</script>

<style>
.body {
    margin: 0 10%;
}
.center {
    text-align: center;
}
.tcTitle{
    font-weight:normal; 
}
.sdgTitle{
    font-size: 45px;
}
.titleBold{
    font-weight: bold;
}
ul {
    list-style: none;
    padding-left: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/PrivacyPolicy/PrivacyPolicy.vue